export default __webpack_public_path__ + "static/media/Saraswati-Medical-College.833d476f.jpeg";